module.exports = __webpack_public_path__ + "static/media/PanelUltraThinLedColoryBlanco.2140d260.pdf";